import { EnterpriseRole } from "@app/common/workspaces/types";

const WORKSPACE_ROLES_ENUM: EnterpriseRole[] = ["admin", "member"];
const TEAM_ROLES_ENUM: EnterpriseRole[] = ["manager", "member"];

export const ROLE_OPTIONS = {
  workspace: WORKSPACE_ROLES_ENUM,
  team: TEAM_ROLES_ENUM,
};

export const ROLE_TO_DISPLAY_NAME = {
  admin: "Admin",
  manager: "Manager",
  member: "User",
  owner: "Owner",
};
